import { ModalPreviewImage } from "components";
import { Fragment, useState } from "react";
import { globalStyles } from "styles";

const PreviewImage = ({ imageUrl, width = 100, height = "auto" }) => {
  const classes = globalStyles();
  const [modalVisible, setModalVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const handlePreviewLogo = item => {
    setModalVisible(true);
    setPreviewImage(item);
  };

  return (
    <Fragment>
      <img
        className={classes?.cursorPointer}
        onClick={() => {
          handlePreviewLogo(imageUrl);
        }}
        src={imageUrl}
        alt=""
        height={height}
        width={width}
      />
      {modalVisible && (
        <ModalPreviewImage
          open={modalVisible}
          onClose={() => setModalVisible(false)}
          imageUrl={previewImage}
        />
      )}
    </Fragment>
  );
};

export default PreviewImage;
